import { Box, Button, Paper, Typography } from '@mui/material';
import { HealthCheck } from '@/components';

const Home = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                height: 'calc(100vh - 200px)',
                position: 'relative',
            }}
        >
            <Paper>
                <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <Typography variant="h4" color="primary" align="center">
                        Welcome to AI Insights
                    </Typography>
                    <Typography variant="body1" align="center">
                        Explore your projects and discover valuable insights from your calls.
                    </Typography>
                    <Button variant="contained" color="primary" href="/projects">
                        Browse projects
                    </Button>
                </Box>
            </Paper>
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 16,
                    right: 16,
                }}
            >
                <HealthCheck />
            </Box>
        </Box>
    );
};

export default Home;
